import React, { useEffect, useRef, useState } from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";
import Stack from "@mui/joy/Stack";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { add, update } from "../../service/industryService";
import { Button } from "primereact/button";
import { templateAdd, templateUpdate } from "../../service/templateService";
import { Grid } from "@mui/material";
import { InputText } from "primereact/inputtext";
import MultiDropdownApi from "../../components/MultiDropdownApi";
import { Editor } from "primereact/editor";
import { QuillEditor } from "../../components/QuillEditor";
import { placeholder } from "../../assets/placeholder";
import ImageS3Upload from "../../components/ImageS3Upload";
import { TabPanel, TabView } from "primereact/tabview";
import { addInductionSlide, updateInductionSlide } from "../../service/inductionService";

export default function InductionAdd(modalProps: any) {
  const record = modalProps.record;

  const id = modalProps.uuid;

  const [title, setTitle] = useState(record?.title || "");
  const [body, setBody] = useState(record?.body || "");
  const [s3Key, setS3Key] = useState(record?.s3_key || `induction/${id}`);
  const [industry, setIndustry] = useState(record?.industry || []);
  const [jobTask, setJobTask] = useState(record?.job_task || []);

  const [photo, setPhoto] = React.useState(record?.photo || placeholder);
  const [file, setFile] = React.useState<File>();

  useEffect(() => {
    if (file instanceof File) {
      const photoUrl = URL.createObjectURL(file);
      setPhoto(photoUrl);
    }
  }, [file]);

  async function addInduction() {
    const updateObject = {
      title,
      industry,
      job_task: jobTask,
      body,
      s3_key: s3Key,
    };

    if (record?.id) {
      updateInductionSlide(record.id, updateObject).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Induction Updated Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    } else {
      addInductionSlide(updateObject).then((r: any) => {
        modalProps.toast.current.show({
          severity: "success",
          summary: "Induction Created Successfully",
          life: 3000,
        });
        modalProps.setVisible(false);
        modalProps.setGlobalLoading(false);
        modalProps.setReload(!modalProps.reload);
      });
    }
  }

  return (
    <React.Fragment>
      <TabView>
        <TabPanel header="Details">
          <br />
          <Grid container spacing={2}>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <FormControl>
                  <ImageS3Upload
                    photo={photo}
                    setPhoto={setPhoto}
                    s3Key={s3Key}
                    file={file}
                    setFile={setFile}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={8}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <FormControl sx={{ flexGrow: 1 }}>
                      <FormLabel>
                        Title<div style={{ color: "red" }}>*</div>
                      </FormLabel>
                      <FormControl
                        sx={{
                          display: { sm: "flex-column", md: "flex-row" },
                          gap: 2,
                        }}
                      >
                        <InputText
                          value={title}
                          onChange={e => setTitle(e.target.value)}
                          type="text"
                          className="p-inputtext-sm PrimeSmallInput"
                        />
                      </FormControl>
                    </FormControl>
                  </Grid>
                </Grid>
                <br />
                <Grid item xs={12}>
                  <MultiDropdownApi
                    showAll={true}
                    apiPath="industry"
                    optionLabel="name"
                    optionValue="id"
                    label="Industry"
                    selectedData={industry}
                    setSelectedData={setIndustry}
                  />
                </Grid>
              </Grid>
              <br />
            </Grid>
            <Grid item xs={12}>
              <MultiDropdownApi
                showAll={true}
                apiPath="risk-job-task"
                optionLabel="name"
                optionValue="id"
                label="Job task"
                selectedData={jobTask}
                setSelectedData={setJobTask}
              />
            </Grid>
            <Grid item xs={12}>
              <QuillEditor
                label="Body"
                content={body}
                setContent={setBody}
                toast={modalProps.toast}
              />
            </Grid>
          </Grid>
        </TabPanel>
        <TabPanel header="Preview">
          <Grid container spacing={2} style={{ width: 350, margin: "auto" }}>
            <Grid item xs={12}>
              <FormControl>
                <img src={photo} style={{ maxHeight: "20vh" }} />
              </FormControl>
            </Grid>
            <Grid style={{ paddingTop: 0 }} item xs={12}>
              <FormControl sx={{ flexGrow: 1 }} style={{ backgroundColor: "#17123a" }}>
                <FormLabel
                  style={{
                    color: "white",
                    fontWeight: "bold",
                    padding: 10,
                    fontSize: "large",
                    margin: "auto",
                  }}
                >
                  {title}
                </FormLabel>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl>
                <div dangerouslySetInnerHTML={{ __html: body }} />
              </FormControl>
            </Grid>
          </Grid>
        </TabPanel>
      </TabView>
      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => addInduction()}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
